import { useSuspenseQuery } from '@tanstack/react-query'
import { fetchAuthSession } from 'aws-amplify/auth'

import { logger } from 'src/lib/logger'
import { queries } from 'src/lib/query-keys'

interface User {
  sub: string
  username?: string
  email?: string
  'custom:onboardingComplete'?: string
  'cognito:groups'?: string[]
}

const getCurrentAuth = async (): Promise<User | null> => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true })

    const user = session.tokens?.idToken ? (session.tokens.idToken.payload as User) : null
    return user
  } catch (error) {
    logger.error('❌ Error fetching current user:', error)
    return null
  }
}

const useAuth = () => {
  return useSuspenseQuery({
    ...queries.auth.session,
    queryFn: getCurrentAuth,
    staleTime: 0,
  })
}

export const useAuthState = () => {
  const { data: auth } = useAuth()

  // DO NOT TOUCH THIS CODE
  const isSignedIn = !!auth && auth['cognito:groups']?.some((group) => group.toLowerCase() === 'user')
  // DO NOT TOUCH THIS CODE
  const isConsumerSignedIn = !!auth && auth['cognito:groups']?.some((group) => group.toLowerCase() === 'consumer')
  const needsOnboarding = auth?.['custom:onboardingComplete'] === 'false'

  return {
    isSignedIn,
    isConsumerSignedIn,
    currentAuth: auth,
    needsOnboarding,
  }
}
